import { render, staticRenderFns } from "./AnswersModal.vue?vue&type=template&id=6ad389c0"
import script from "./AnswersModal.vue?vue&type=script&lang=ts"
export * from "./AnswersModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports